import React from "react";
import { Button } from "@mui/material";
import { MenuBookOutlined, OpenInNewRounded } from "@mui/icons-material";
import { GUIA_UTILIZACAO_URL } from "../../config/ajuda";

export default function BotaoGuiaUtilizacao({
  href = GUIA_UTILIZACAO_URL,
  sx,
}) {
  const endereco = href.trim();

  return (
    <Button
      component={endereco ? "a" : "button"}
      {...(endereco
        ? { href: endereco, target: "_blank", rel: "noopener noreferrer" }
        : { type: "button" })}
      disabled={!endereco}
      fullWidth
      startIcon={<MenuBookOutlined />}
      endIcon={<OpenInNewRounded />}
      aria-label="Guia de Utilização do SEAR (abre em nova aba)"
      sx={{
        minHeight: 42,
        px: 1.5,
        py: 1,
        borderRadius: "6px",
        backgroundColor: "var(--sear-superficie-azul, #e0ecff)",
        color: "var(--sear-azul, #0060ef)",
        textTransform: "none",
        fontSize: "13px",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "var(--sear-acao-azul-hover, #0060ef)",
          color: "#ffffff",
        },
        ...sx,
      }}
    >
      Guia de Utilização do SEAR
    </Button>
  );
}
